import Constants from '../definitions/constants';
import { intl } from '../locales/localesConfig';

const UserTooling = {
  getUserRolesArray: () => {
    var rolesArray = [];
    Object.keys(Constants.app.userRoles).forEach(function(key,index) {
        var roleValue = Constants.app.userRoles[key];
        rolesArray.push({ 
          value: roleValue,
          label: intl.formatMessage({ id: "user.roles." + roleValue })
        });            
    });
    return rolesArray;
  }
};

export default UserTooling;


// WEBPACK FOOTER //
// ./source/tooling/userTooling.js